import React from 'react';
import merge from 'lodash/merge';
import ReactApexChart from 'react-apexcharts';
import { useTheme, styled } from '@mui/material/styles';
import { Card, CardHeader } from '@mui/material';

import { fNumber } from '../../../../../services/functions';
import { BaseOptionChart } from '../../../../../components/chart';

// ----------------------------------------------------------------------

const CHART_HEIGHT = 392;
const LEGEND_HEIGHT = 150;

const ChartWrapperStyle = styled('div')(({ theme }) => ({
  height: CHART_HEIGHT,
  marginTop: theme.spacing(5),
  '& .apexcharts-canvas svg': { height: CHART_HEIGHT },
  '& .apexcharts-canvas svg,.apexcharts-canvas foreignObject': {
    overflow: 'visible'
  },
  '& .apexcharts-legend': {
    height: LEGEND_HEIGHT,
    alignContent: 'center',
    position: 'relative !important',
    borderTop: `solid 1px ${theme.palette.divider}`,
    top: `calc(${CHART_HEIGHT - LEGEND_HEIGHT}px) !important`
  }
}));

// ----------------------------------------------------------------------


export const OrderDistributionChartBase = props => {
  const { data } = props;
  const theme = useTheme();

  const chartOptions = merge(BaseOptionChart(), {
    // colors: [
    //   theme.palette.primary.lighter,
    //   theme.palette.primary.light,
    //   theme.palette.primary.main,
    //   theme.palette.primary.dark
    // ],
    labels: ['Rezerwacja', 'Potwierdzone', 'Brak miejsc', 'Rezygnacja', 'Anulowane', 'Duplikat', 'Lista rezerwowa'],
    stroke: { colors: [theme.palette.background.paper] },
    legend: { floating: true, horizontalAlign: 'center' },
    tooltip: {
      fillSeriesColor: false,
      y: {
        formatter: seriesName => fNumber(seriesName),
        title: {
          formatter: seriesName => `${seriesName}`
        }
      }
    },
    plotOptions: {
      pie: {
        donut: {
          size: '90%',
          labels: {
            value: {
              formatter: val => fNumber(val)
            },
            total: {
              formatter: w => {
                const sum = w.globals.seriesTotals.reduce((a, b) => a + b, 0);

                return fNumber(sum);
              },
              label: 'Łącznie'
            }
          }
        }
      }
    }
  });

  return (
    <Card sx={{ mt: 5 }}>
      <CardHeader title="Statusy zamówień" titleTypographyProps={{ variant: 'h4' }} />
      <ChartWrapperStyle dir="ltr">
        <ReactApexChart type="donut" series={data} options={chartOptions} height={280} />
      </ChartWrapperStyle>
    </Card>
  );
};
